module.exports = __webpack_public_path__ + "img/main-visual-2.jpg";